import {createAction} from 'redux-actions';

export const helpRequest = createAction('HELP_REQUEST');
export const helpSuccess = createAction('HELP_SUCCESS');
export const helpFailure = createAction('HELP_FAILURE');
